import { ref, Ref } from 'vue'
import { LocationQueryValue } from 'vue-router'

export type StateFieldConfig<T = StateField> = {
  routeQuery?: string
  routeParam?: string

  inputName?: string
  label?: string
  inputHeadingLevel?: 1 | 2 | 3 | 4 | 5 | 6
  description?: string

  toRouteValueOverride?: (instance: T) => string | undefined
  pullRouteQueryValueOverride?: (
    instance: T,
    value: LocationQueryValue | LocationQueryValue[]
  ) => void
  pullRouteParamValueOverride?: (instance: T, value: string | string[]) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toRequestVariableOverride?: (instance: T, variation: number) => Promise<any>
  resetValueOverride?: (instance: T) => void
}

export abstract class StateField {
  readonly type: string = 'abstract'
  updated: Ref<boolean>
  error: Ref<string>

  routeQuery?: string
  routeParam?: string

  inputName?: string
  label?: string
  inputHeadingLevel?: 1 | 2 | 3 | 4 | 5 | 6
  description?: string

  protected toRouteValueOverride?: (instance: this) => string | undefined
  protected pullRouteQueryValueOverride?: (
    instance: this,
    value: LocationQueryValue | LocationQueryValue[]
  ) => void
  protected pullRouteParamValueOverride?: (
    intance: this,
    value: string | string[]
  ) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected toRequestVariableOverride?: (
    instance: this,
    variation: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<any>
  protected resetValueOverride?: (instance: this) => void

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(config: StateFieldConfig<any> = {}) {
    this.updated = ref(false)
    this.error = ref('')

    this.toRouteValueOverride = config.toRouteValueOverride
    this.pullRouteQueryValueOverride = config.pullRouteQueryValueOverride
    this.pullRouteParamValueOverride = config.pullRouteParamValueOverride
    this.toRequestVariableOverride = config.toRequestVariableOverride
    this.resetValueOverride = config.resetValueOverride

    if (config.routeQuery) this.routeQuery = config.routeQuery
    if (config.routeParam) this.routeParam = config.routeParam

    if (config.inputName) this.inputName = config.inputName
    if (config.label) this.label = config.label
    if (config.description) this.description = config.description
    if (config.inputHeadingLevel)
      this.inputHeadingLevel = config.inputHeadingLevel
  }

  abstract toRouteValue(): string | undefined

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract pullRouteQueryValue(
    value: LocationQueryValue | LocationQueryValue[]
  ): void

  abstract pullRouteParamValue(value: string | string[]): void

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract toRequestVariable(variation: number): Promise<any>

  abstract resetValue(): void

  resetError(): void {
    this.error.value = ''
  }
}
